var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff3C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.22 172.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#232323;}.cls-2{fill:#f7ceb7;}.cls-3{fill:#d8823a;}.cls-4{fill:#1199a1;}.cls-5{fill:#0e5279;}.cls-6{fill:#004568;}.cls-7{fill:#14adb2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Formulering_Stabilisering",
    "data-name": "Formulering Stabilisering"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.47,162.91c-4.39-1.82-10.23-2.39-12.56-1.07s3.45,6.13,10.18,9.08,8.41,1.89,9.84.43-.57-6.18-.57-6.18A37.28,37.28,0,0,1,28.47,162.91Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.46,148.73c-3.32-.43-5.81,2-3.1,4s5.76,3.33,10.2,5.77c6.51,3.58,8.64.66,8.42-.89s-.66-6.43-.66-6.43S46.78,149.16,43.46,148.73Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.56,33.51s-.22-4.21-.44-6.21c0,0-4.43-.64-5.32-2.22s-1.11-8.46-.89-14,5.57-8,9.31-8.86S51.28,1.13,55.05,8.64s-2.22,14.63-7.54,17.51l.22,6Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.86,6c-1.33,6.9,8.43,10,8.43,10,1.38-2.74,5.19-.83,4.87,2.33s-2,4.32-3.32,4.1c-.22,2,3.1,3.36,6.65,3.77s10.42-5.79,10.86-12a11.43,11.43,0,0,0,0-1.85A6.2,6.2,0,1,0,51.5,2a13.76,13.76,0,0,0-6.87-2C38,0,33.77,2.66,30.86,6Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.06,60.25c4.43,2,8.85,1.13,10.64-.66s1.77-7.76,1.11-12.86C62.8,39,61.12,33.56,59.39,31s-5.16-4.49-8-2.66C48.29,30.32,47.63,58.25,52.06,60.25Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24,121.92s.23,30.37.67,39.68C24.93,168,37,171.37,37,164.71s.89-29.05,1.11-39.24Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.85,116s1.7,26.57,2,35c.22,6.21-11.75,4.43-12.19,0s-1.56-13.52-2.44-28.16Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.51,67.82l-8.65-4.21-6.2-.44L2.45,60.29S.22,57,0,55.44A2.68,2.68,0,0,1,1.12,53a76.8,76.8,0,0,1,7.76,2S5.13,51.68,6,51.23s2.66.44,4.87,1.77a36.4,36.4,0,0,1,5.55,4.9L24.84,61Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M58.54,37.9c1.11,6.43.68,13.1-.41,20.86-1.45,10.11.43,17.49,1.1,27.49s1.33,26.58,1.78,35c-5.1,6.21-16.58,6.88-21.73,7.1s-15.57-.22-20-5.1c0,0,.89-12,2-23.5s4-20.18,4.88-25.94,2.18-32.83,4-37.47,8.39-6,15.82-7.64C56.52,26.36,57.55,32.18,58.54,37.9Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.92,50.09C36.59,57,32.15,68.3,28.83,69.85S18,68.3,14.64,66.08c-3.73-2.49-1.1-8.42,1.78-8.2s7.76.44,7.76.44.43-4.68,1.1-12,3.41-14,7.76-13.08C39.69,34.57,39.25,43.18,37.92,50.09Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff3C);
export default __webpack_public_path__ + "static/media/staff-3-c.9fbae35562a15b14af5685b11b630724.svg";
export { ForwardRef as ReactComponent };